import { type PlaygroundRole } from '@playground/features/auth/playgroundRole'
import {
  createRootRouteWithContext,
  Navigate,
  Outlet,
} from '@tanstack/react-router'

/**
 * The role reaches routes through the router context rather than React context,
 * because `beforeLoad` runs outside the component tree — which is the point: a
 * route an account may not see is never entered, so its loaders never run.
 *
 * Supplied at render time by `AppRouter`, since it comes from a hook.
 */
export interface PlaygroundRouterContext {
  role: PlaygroundRole
}

export const Route = createRootRouteWithContext<PlaygroundRouterContext>()({
  component: () => <Outlet />,
  notFoundComponent: () => <Navigate to="/" replace />,
})
